import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d2776c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "g-card express-rate-form" }
const _hoisted_4 = { class: "form-item our-country" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label is-required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "收件国家/地区"),
  /*#__PURE__*/_createElementVNode("span", { class: "title-en" }, "Country/Region")
], -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dashed" }, null, -1))
const _hoisted_7 = { class: "form-item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label is-required" }, [
  /*#__PURE__*/_createElementVNode("span", null, "重量"),
  /*#__PURE__*/_createElementVNode("span", { class: "title-en" }, "Weight")
], -1))
const _hoisted_9 = { class: "form-item-input" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-suffix" }, "kg", -1))
const _hoisted_11 = { class: "show-dimension" }
const _hoisted_12 = {
  key: 0,
  class: "form-item"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label" }, [
  /*#__PURE__*/_createElementVNode("span", null, "尺寸")
], -1))
const _hoisted_14 = { class: "form-group-item-input" }
const _hoisted_15 = { class: "form-item-input" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-suffix" }, "cm", -1))
const _hoisted_17 = { class: "form-item-input" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-suffix" }, "cm", -1))
const _hoisted_19 = { class: "form-item-input" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-suffix" }, "cm", -1))
const _hoisted_21 = { class: "express-list" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-item-label is-required express-list-header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "title" }, "线路"),
  /*#__PURE__*/_createElementVNode("span", { class: "title-en" }, "Cargo Types")
], -1))
const _hoisted_23 = { class: "g-card" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = { class: "note" }
const _hoisted_26 = { class: "info" }
const _hoisted_27 = { class: "time" }
const _hoisted_28 = {
  key: 0,
  class: "price-badge"
}
const _hoisted_29 = {
  class: "price",
  "wx:key": "{{item.id}}"
}
const _hoisted_30 = { class: "charge" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "g-fixed-safearea" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CountryPicker = _resolveComponent("CountryPicker")!
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          (_ctx.displayCountryInfo)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "form-item-checkbox g-input",
                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPicker && _ctx.showPicker(...args)))
              }, _toDisplayString(_ctx.displayCountryInfo.name) + " " + _toDisplayString(_ctx.displayCountryInfo.nameCn), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_CountryPicker, {
            modelValue: _ctx.reqForm.country,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.reqForm.country) = $event)),
            "is-show-picker": _ctx.isShowPicker,
            onCancel: _ctx.onClosePicker
          }, null, 8, ["modelValue", "is-show-picker", "onCancel"])
        ]),
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _withDirectives(_createElementVNode("input", {
              class: "g-input has-suffix",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reqForm.weight) = $event)),
              "placeholder-class": "g-input__placeholder",
              onConfirm: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.estimatePackage && _ctx.estimatePackage(...args))),
              type: "number"
            }, null, 544), [
              [_vModelText, _ctx.reqForm.weight]
            ]),
            _hoisted_10
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("span", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.toggleDimension && _ctx.toggleDimension(...args)))
          }, _toDisplayString(_ctx.reqForm.dimensionVisible ? '收起' : '输入尺寸计价更准确'), 1)
        ]),
        (_ctx.reqForm.dimensionVisible)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _withDirectives(_createElementVNode("input", {
                    class: "g-input has-suffix",
                    placeholder: "长",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.reqForm.sizeLength) = $event)),
                    "placeholder-class": "g-input__placeholder",
                    bindconfirm: "estimatePackage",
                    type: "number"
                  }, null, 512), [
                    [_vModelText, _ctx.reqForm.sizeLength]
                  ]),
                  _hoisted_16
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _withDirectives(_createElementVNode("input", {
                    class: "g-input has-suffix",
                    placeholder: "宽",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.reqForm.sizeWidth) = $event)),
                    "placeholder-class": "g-input__placeholder",
                    bindconfirm: "estimatePackage",
                    type: "number"
                  }, null, 512), [
                    [_vModelText, _ctx.reqForm.sizeWidth]
                  ]),
                  _hoisted_18
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _withDirectives(_createElementVNode("input", {
                    class: "g-input has-suffix",
                    placeholder: "高",
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.reqForm.sizeHeight) = $event)),
                    "placeholder-class": "g-input__placeholder",
                    bindconfirm: "estimatePackage",
                    type: "number"
                  }, null, 512), [
                    [_vModelText, _ctx.reqForm.sizeHeight]
                  ]),
                  _hoisted_20
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          "hover-class": "hover",
          class: "g-button g-button-primary estimate",
          onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.estimatePackage && _ctx.estimatePackage(...args)))
        }, " 测算 ")
      ]),
      _createElementVNode("div", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("div", _hoisted_23, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.expressList, (item) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "express-item",
              key: item.id
            }, [
              _createElementVNode("div", {
                class: "title",
                onClick: ($event: any) => (_ctx.showExpressNote(item.note1))
              }, _toDisplayString(item.title), 9, _hoisted_24),
              _createElementVNode("div", _hoisted_25, _toDisplayString(item.note1), 1),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  _createVNode(_component_Icon, {
                    class: "icon-express-time",
                    icon: "icon_time"
                  }),
                  _createTextVNode(" " + _toDisplayString(item.estimated_delivery_time), 1)
                ]),
                (_ctx.priceList && _ctx.priceList[item.id])
                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createTextVNode(_toDisplayString(_ctx.priceList[item.id].rate_weight ? '预估￥' : '') + " ", 1),
                        _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.priceList[item.id].price), 1)
                      ]),
                      (_ctx.priceList[item.id].rate_weight)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            "hover-class": "hover",
                            class: "g-button g-button-danger goto-order",
                            onClick: ($event: any) => (_ctx.gotoOrder(item))
                          }, " 立即下单 ", 8, _hoisted_31))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _hoisted_32
  ]))
}